// Plural Actions
export const GET_MW_NAMES = "GET_MW_NAMES";
export const getMWNames = (opts = {}) => {
  const params = opts.refresh ? { refresh: "true" } : {};
  const request = axios.get("/moneyworks/names.json", { params });
  return {
    type: GET_MW_NAMES,
    payload: request,
  };
};
